<template>
    <div id="hire_me_main" v-if="contents">
        <div class="resume-item-wrap" :class="{ last: i === contents.length - 1 }" v-for="(item, i) in contents" :key="item.text" :id="underscore(item.text)">
            <div class="timeline" v-if="i !== contents.length - 1"></div>
            <div class="timeline-circle"></div>
            <div class="resume-item-content">
                <h1 class="resume-item-title">{{item.text}}</h1>
                <p class="date">{{item.date}}</p>
                <template v-if="item.component">
                    <component :is="item.component"/>
                </template>
                <div v-else>
                    <p>{{lorem}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lorem from '@/helpers/lorem'
    import debounce from '@/helpers/debounce'

    import NvcTimeline from '@/views/HireMe/Timeline/NvcTimeline'
    import FiTimeline from '@/views/HireMe/Timeline/FiTimeline'
    import MachineLearningTimeline from '@/views/HireMe/Timeline/MachineLearningTimeline'
    import ResearchTimeline from '@/views/HireMe/Timeline/ResearchTimeline'
    import CourseAssistantTimeline from '@/views/HireMe/Timeline/CourseAssistantTimeline'
    import FreelanceTimeline from '@/views/HireMe/Timeline/FreelanceTimeline'
    import SoftwareEngineerTimeline from '@/views/HireMe/Timeline/SoftwareEngineerTimeline'


    let els = []

    export default {
        name: "HireMeMain",
        components: {
            NvcTimeline,
            FiTimeline,
            MachineLearningTimeline,
            ResearchTimeline,
            CourseAssistantTimeline,
            FreelanceTimeline,
            SoftwareEngineerTimeline
        },
        props: {
            contents: Array
        },
        data () {
            return {
                lorem: lorem(),
            } 
        },
        computed: {

        },
        methods: {
            underscore (text) {
                text = text.replace(/\(.*\)/g, '').trim()
                return text.replace(/\s/g, '_')
            },
            scrollListenHandler () {
                let hash = ''
                for (let i = 0; i < els.length; i ++) {
                    if (window.pageYOffset + 200 >= els[i].offsetTop) {
                        hash = this.underscore(this.contents[i].text)
                    } else {
                        break
                    }
                }
                if (this.$route.name === 'HireMe' && this.$route.hash !== '#' + hash) {
                    this.$router.replace({ hash: '#' + hash })
                }
            },
        },
        mounted () {
            setTimeout(() => {
                els = this.contents.map(c => document.getElementById(this.underscore(c.text)))
                this._debouncedScrollListenHandler = debounce(this.scrollListenHandler, 50)
                window.addEventListener('scroll', this._debouncedScrollListenHandler)
            }, 200);
        },
        unmounted () {
            window.removeEventListener('scroll', this._debouncedScrollListenHandler)
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/variables";

    $timeline-width: 10px;
    $timeline-color: $green;

    #hire_me_main {
        margin: auto;
        max-width: 780px;
    }

    .resume-item-wrap {
        position: relative;
        margin-bottom: 2*$timeline-width;

        &.last {
            min-height: 500px;
        }

        .timeline {
            margin-left: -10px;
            position: absolute;
            width: $timeline-width;
            background: $timeline-color;
            top: 3*$timeline-width;
            left: $timeline-width;
            height: 100%;
        }

        .timeline-circle {
            margin-left: -10px;
            position: absolute;
            width: $timeline-width;
            height: $timeline-width;
            border-radius: 50%;
            top: 4px;
            left: 0;
            border: $timeline-width solid $timeline-color;
        }

        .resume-item-content {
            margin-left: $timeline-width*4;

            ::v-deep p {
                line-height: $reading-line-height;
            }

            h1 {
                font-size: 1.5rem;
            }

            .resume-item-title {
                margin-bottom: 0;
            }

            .date {
                margin: 0;
                color: #aaaaaa;
            }
        }

    }
</style>